import { useTranslation } from "react-i18next"
import CheckBox from "src/component/CheckBox"
import { RecurringDecisionMedicine } from "src/types/Requests/MobRecurringRequests"
import "./style.css"
import { Icon } from "@iconify/react"
import { Alert } from "src/component/Alert"

interface IMedicineAccordionTitle {
    medicine: RecurringDecisionMedicine
    isSelected: boolean
    totalPrice: string
    isOpened: boolean
    onSelect: (value: boolean) => void
    onToggle: () => void
}


const MedicineAccordionTitle = ({ medicine, isSelected, totalPrice, isOpened, onSelect, onToggle }: IMedicineAccordionTitle) => {
    const { t } = useTranslation()

    return (
        <div
            className={`medicine-accordion-header ${isSelected ? 'selected' : ''} ${isOpened ? 'opened' : 'closed'}`}
            onClick={onToggle}
        >
            <div className="accordion-header-content">
                <div className="accordion-header-left" >
                    <div onClick={(e) => {
                        e.stopPropagation()
                    }}>
                        <CheckBox
                            value={isSelected}
                            setValue={onSelect}
                            className="medicine-checkbox"
                        />
                    </div>

                    <p className="medicine-name">{medicine.medicineName}</p>
                </div>
                <div className="accordion-header-right">
                    <div className="medicine-summary">
                        <div className="summary-item">
                            <span className="summary-label">{t("units-amount")}</span>
                            <span className="summary-value">{medicine.amount}</span>
                        </div>
                        <div className="summary-item">
                            <span className="summary-label">{t("units-cost")}</span>
                            <span className="summary-value">{totalPrice}</span>
                        </div>
                    </div>
                    <button
                        className="accordion-toggle-btn"
                        type="button"
                        onClick={(e) => {
                            onToggle()
                            e.stopPropagation()
                        }}
                    >
                        <span className={`toggle-icon ${isOpened ? 'rotated' : ''}`}><Icon icon="bxs:down-arrow" fontSize={15} /></span>
                    </button>
                </div>
            </div>
            {medicine?.duplicatePatientMedicine && (
                <Alert variant="danger">
                    {t("duplicatePatientMedicineAlertFull", {
                        amount: medicine?.duplicatePatientMedicine?.amount,
                        decisionNumbers: medicine?.duplicatePatientMedicine?.decisionNumbers.join(", "),
                    })}
                </Alert>
            )}
        </div>
    )
}

export default MedicineAccordionTitle
